import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-c21b3f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = { class: "TumiLogin" }
const _hoisted_3 = { class: "TumiForm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white mb-3" }, "Welcome to", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "mb-3 TumiLogoLola"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "Sign up to start protecting your projects", -1))
const _hoisted_7 = { class: "mb-3 mt-4" }
const _hoisted_8 = { class: "d-grid gap-2" }
const _hoisted_9 = { class: "text-center mt-3" }
const _hoisted_10 = {
  key: 0,
  class: "spinner-border TumiSpinner text-light",
  role: "status"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "TumiErrorLogin mt-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-white"
}
const _hoisted_15 = {
  key: 1,
  class: "TumiTextWarning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
            placeholder: "Email"
          }, null, 512), [
            [_vModelText, _ctx.mail]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pass) = $event)),
            placeholder: "Password"
          }, null, 512), [
            [_vModelText, _ctx.pass]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pass2) = $event)),
            placeholder: "Repeat password"
          }, null, 512), [
            [_vModelText, _ctx.pass2]
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SignUp && _ctx.SignUp(...args))),
              class: "btn btn-info"
            }, "Sign Up")
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.waiting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.next)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "An Email has been sent to you mailbox. Click on the link to confirm your email!"))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}